import { toast as sonnerToast } from 'sonner';

export function useToast() {
  return {
    toast: (props: { title?: string; description?: string; variant?: 'default' | 'destructive' }) => {
      if (props.variant === 'destructive') {
        sonnerToast.error(props.title || props.description || '');
      } else {
        sonnerToast(props.title || props.description || '');
      }
    },
  };
}
